import type { IProductSearchGeoContext } from "./product-search-geo-context.interface";

const PRODUCT_SEARCH_QUERY_KEYS = "product-search";

export const productSearchQueryKeys = {
  all: [PRODUCT_SEARCH_QUERY_KEYS] as const,
  search: function search(searchText: string, geoContext?: IProductSearchGeoContext) {
    return [
      PRODUCT_SEARCH_QUERY_KEYS,
      "search",
      searchText,
      geoContext?.regionName ?? null,
      geoContext?.municipalityCode ?? null,
    ] as const;
  },
};
